import axios from "axios";

axios.defaults.withCredentials = true;
export default function tenantIdHeader() {
    // return authorization header with jwt token
    // let uid = uuid.v1()

    // let uid = new Date().getTime() + "a"

    let uid = Math.random().toString(36).substring(2, 11);
    let uid2 = Math.random().toString(36).substring(2, 9);

    let tenantId = JSON.parse(localStorage.getItem("tenantId"));
    let userId = JSON.parse(localStorage.getItem("userId"));

    let header = {
        "X-B3-TraceId": uid + uid2,
        "X-B3-SpanId": uid + uid2,
        "Access-Control-Allow-Credentials": "true",
    }

    if (tenantId) {
        header["x-tenant-id"] = tenantId;
    }
    if (userId) {
        header["x-user-id"] = userId;
    }
    return header;
}
